export class StringUtils {
  public static toTitleCase(str: string): string {
    return str.replace(/\b\w+/g, function (s) {
      return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();
    });
  }
}
